import React from "react"
import PropTypes from "prop-types"

import "./index.scss"

export default function BillingCancelContainer({
  unlimitedAppletEnables,
  urls,
  userTier,
}) {
  let header = "Switch to Free?"
  let body = (
    <>
      <p>
        {userTier === "pro" && (
          <>
            <b>
              By canceling your Pro+ subscription, you will lose all but 5 of
              your Applets, as well as access to filter code, queries, and
              multiple service connections.
            </b>{" "}
            Are you sure you want to cancel Pro+?
          </>
        )}
        {userTier == "legacy_pro" && (
          <>
            <b>
              By canceling your Pro subscription, you will lose all but 5 of
              your Applets, as well as access to filter code and queries.
            </b>{" "}
            Are you sure you want to cancel Pro?
          </>
        )}
        {userTier == "intermediate_pro" && (
          <>
            <b>
              With Pro, you can create up to 20 Applets and have access to
              multi-actions.
            </b>{" "}
            If you cancel your subscription, you will lose all but 5 of your
            Applets. Are you sure you want to cancel Pro?
          </>
        )}
      </p>
      {unlimitedAppletEnables && (
        <p styleName="unlimited_enables_warning">
          You will continue to have access to unlimited Applet enables even if
          you cancel your plan.
        </p>
      )}
    </>
  )
  let continueButtonLabel = "Stay Pro"
  let cancelLabel = "Cancel my Pro plan"

  if (userTier === "pro") {
    continueButtonLabel = "Stay Pro+"
    cancelLabel = "Cancel my Pro+ plan"
  }

  return (
    <form
      action={urls.processProCancellation}
      method="post"
      onSubmit={() => window.Turbolinks.clearCache()}
      styleName="form"
    >
      <input
        type="hidden"
        name="authenticity_token"
        value={window.App.authenticityToken}
      />

      <section styleName="cancel-pro-header">
        <h1>{header}</h1>
        {body}
      </section>

      <section styleName="stay-pro-or-not">
        <a
          href={urls.billing}
          role="button"
          className="button-primary"
          styleName="stay-pro"
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "stay_pro_button",
            location_type: "cancel_plan_confirmation",
          })}
        >
          {continueButtonLabel}
        </a>
        <button
          styleName="cancel-pro"
          data-disable-with="Cancelling…"
          data-track-ifttt-next-event="click"
          data-track-data={JSON.stringify({
            object_type: "cancel_pro_plan_button",
            location_type: "cancel_plan_confirmation",
          })}
        >
          {cancelLabel}
        </button>
      </section>
    </form>
  )
}

BillingCancelContainer.propTypes = {
  unlimitedAppletEnables: PropTypes.bool,
  urls: PropTypes.shape({
    billing: PropTypes.string.isRequired,
    processProCancellation: PropTypes.string.isRequired,
  }),
  userTier: PropTypes.oneOf(["free", "legacy_pro", "intermediate_pro", "pro"]),
}

BillingCancelContainer.defaultPropTypes = {
  unlimitedAppletEnables: false,
}
